import * as React from "react";
import * as $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/themes/base/all.css";
import { RioAutoCompleteResult, RioUnsafe, RioResources} from "rio.react.all";

interface IAutoCompleteProps {
    value?: string;
    suggestionMinimumChars?: number;

    onGetText: (value: string) => Promise<string>;
    onGetOptions: (text: string) => Promise<Array<RioAutoCompleteResult>>;
    onValueChanged: (value?: string) => void;

    name?: string;
}

interface IAutoCompleteState {
    text: string;
    value?: string;
}

//interface JQuery {
//    autocomplete(...args: any): any;
//}

//declare var $: any

export class AutoComplete extends React.Component<IAutoCompleteProps, IAutoCompleteState> {
    constructor(props: Readonly<IAutoCompleteProps>) {
        super(props);

        this.state = {
            value: null,
            text: ""
        };
    }

    private input = React.createRef<HTMLInputElement>();

    render() {
        if (this.props.value !== this.state.value) {
            this.setValue(this.props.value);
        }

        return (
            <span className="autoComplete">
                <input
                    name={this.props.name}
                    type="text"
                    ref={this.input}
                    value={this.state.text}
                    onChange={(e) => this.handleInputChange(e)}
                    onBlur={(e) => this.handleInputBlur(e)}
                />
                <RioUnsafe html={RioResources.find("SearchPlaceholder").image} />
            </span>


        );
    }

    componentDidMount(): void {
        $(this.input.current).autocomplete({
            source: (request: any, response: any) => {
                if (!!this.props.suggestionMinimumChars && request.term.length < this.props.suggestionMinimumChars) {
                    response([]);
                } else {
                    this.props.onGetOptions(request.term).then(v => response(v));
                }            },
            select: (event: Event, ui: { item: RioAutoCompleteResult; }) => {
                this.handleItemSelected(event, ui.item);
            }
        });
    }

    handleInputChange(e: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ text: e.target.value });
    }

    handleInputBlur(e: React.FocusEvent<HTMLInputElement>): void {
        if (!e.target.value.length) {
            this.setValue(null);
            this.props.onValueChanged(null);
        } else {
            this.setValue(this.state.value);
        }
    }

    handleItemSelected(event: Event, item: RioAutoCompleteResult) {
        event.preventDefault();
        this.setState({
            text: item.label,
            value: item.value
        });
        this.props.onValueChanged(item.value);
    }
    
    setValue(value: string): void {
        if (value == undefined) {
            this.setState({
                value: value,
                text: ""
            });
        } else {
            this.props.onGetText(value).then(t => {
                this.setState({
                    value: value,
                    text: t
                });
            })
        }
    }
}
